import React from "react";
import { Box, Typography } from "@mui/material";

import { useNavigate } from "react-router-dom";
import classes from "./newsForm.module.scss";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const MAX_LENGTH = 65;

const NewsForm = () => {
  const { newsList, newsListStatus } = useSelector((state) => state.news);
  const navigate = useNavigate();

  const { i18n } = useTranslation();
  const currentLang = i18n.language; // например: "en", "ru", "ky"

  const handleNavigate = (slug) => {
    if (!slug) return;
    navigate(`${slug}`);
  };

  // Берём первый элемент, если есть
  const firstItem = newsList?.results?.[0];

  // Берём заголовок с учётом языка, fallback на русский или просто title
  const firstTitle =
    firstItem?.[`title_${currentLang}`] || firstItem?.title_ru || firstItem?.title || "";

  return (
    <Box className={classes.grid}>
      {firstItem && (
        <Box
          className={classes.allNews}
          onClick={() => handleNavigate(firstItem.slug)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleNavigate(firstItem.slug);
          }}
        >
          <Box
            className={classes.newsImg}
            component="img"
            src={firstItem?.news_images?.[0]?.image}
            alt={firstTitle}
          />
          <Box className={classes.titleFirst}>
            <Typography className={classes.titleMore}>
              {firstTitle.length > MAX_LENGTH ? firstTitle.slice(0, MAX_LENGTH) + "..." : firstTitle}
            </Typography>
          </Box>
        </Box>
      )}

      <Box className={classes.allColumn}>
        {newsListStatus === "succeeded" &&
          newsList?.results
            ?.slice(1, 4)
            .map((item) => {
              const title =
                item?.[`title_${currentLang}`] || item?.title_ru || item?.title || "";

              return (
                <Box
                  key={item.id}
                  className={classes.column}
                  onClick={() => handleNavigate(item.slug)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") handleNavigate(item.slug);
                  }}
                >
                  <Box className={classes.newsIcons}>
                    <img
                      className={classes.newsImages}
                      alt={title}
                      src={item?.news_images?.[0]?.image}
                    />
                  </Box>
                  <Box className={classes.titleSecond}>
                    <Typography className={classes.description}>
                      {title.length > MAX_LENGTH ? title.slice(0, MAX_LENGTH) + "..." : title}
                    </Typography>
                  </Box>
                </Box>
              );
            })}
      </Box>
    </Box>
  );
};

export default NewsForm;
